import { AnyAction } from 'redux'

import { IAccountStatus, IUserStatus } from 'models/user.model'

import {
  SET_ACCOUNT_CREATION_FLOW_PENDING,
  SET_ACCOUNT_STATUS,
  SET_LEARNWORLDS_LINK,
  SET_ONE_LINK,
  SET_STATUS,
  SET_TEST_ENVIRONMENT_QUERY_PARAM,
  SET_UUID,
  UPDATE_USER_CONFIG,
} from '../actions/user'

export interface IUserState {
  uuid: string
  status: IUserStatus | null
  oneLink: string
  learnworldsLink: string
  testEnvironmentQueryParam: string
  isAccountCreationFlowPending: boolean
  accountStatus: IAccountStatus
}

const initState: IUserState = {
  uuid: '',
  status: null,
  oneLink: '',
  learnworldsLink: '',
  testEnvironmentQueryParam: '',
  isAccountCreationFlowPending: false,
  accountStatus: {
    existingUuid: '',
    hasAccount: null,
    hasAccessToApp: null,
  },
}

export function userReducer(
  state: IUserState = initState,
  { type, payload = null }: AnyAction,
): IUserState {
  switch (type) {
    case SET_UUID: {
      return {
        ...state,
        uuid: payload,
      }
    }
    case SET_STATUS: {
      return {
        ...state,
        status: payload,
      }
    }
    case SET_ONE_LINK: {
      return {
        ...state,
        oneLink: payload,
      }
    }
    case SET_LEARNWORLDS_LINK: {
      return {
        ...state,
        learnworldsLink: payload,
      }
    }
    case SET_TEST_ENVIRONMENT_QUERY_PARAM: {
      return {
        ...state,
        testEnvironmentQueryParam: payload,
      }
    }
    case SET_ACCOUNT_CREATION_FLOW_PENDING: {
      return {
        ...state,
        isAccountCreationFlowPending: payload,
      }
    }
    case SET_ACCOUNT_STATUS: {
      return {
        ...state,
        accountStatus: payload,
      }
    }
    case UPDATE_USER_CONFIG: {
      return {
        ...state,
        status: state.status
          ? {
              ...state.status,
              config: {
                ...state.status.config,
                ...payload,
              },
            }
          : state.status,
      }
    }
    default:
      return state
  }
}
